import React, { useEffect, useState } from 'react'

// Builder.io dependencies
import { Builder, BuilderComponent, builder } from '@builder.io/react'

const HeroBillBoard = ({ ...rest }) => {
  const [heroBillBoard, setHeroBillBoard] = useState(null)

  useEffect(() => {
    builder
      .get('hero', {
        userAttributes: {
          urlPath: '/signed-out-hp-hero-billboard'
        }
      })
      .toPromise()
      .then((heroBillBoardSection) => setHeroBillBoard(heroBillBoardSection))
  }, [])

  return <BuilderComponent model='hero' content={heroBillBoard} />
}

export default HeroBillBoard
